var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { LandingPage } from 'packages/landing_pages/LandingPage';
import { EntityBuilder } from '@decahedron/entity';
var LandingPagesRepository = /** @class */ (function (_super) {
    __extends(LandingPagesRepository, _super);
    function LandingPagesRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.url = 'api/v2/landing-pages';
        _this.entity = LandingPage;
        return _this;
    }
    LandingPagesRepository.prototype.showLandingPage = function (stringIdentifier, accessToken) {
        var _this = this;
        return this.get(this.url + "/public/" + stringIdentifier, null, {
            resource_access_token: accessToken,
        }).then(function (response) {
            var result = _this.responseTransformer(response);
            return EntityBuilder.buildOne(_this.entity, result.data);
        });
    };
    return LandingPagesRepository;
}(AbstractRepository));
export { LandingPagesRepository };
